const ar = {
  // Common
  common: {
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    update: 'تحديث',
    close: 'إغلاق',
    confirm: 'تأكيد',
    search: 'بحث',
    filter: 'تصفية',
    reset: 'إعادة تعيين',
    refresh: 'تحديث',
    view: 'عرض',
    print: 'طباعة',
    export: 'تصدير',
    all: 'الكل',
    none: 'لا شيء',
    yes: 'نعم',
    no: 'لا',
    ok: 'موافق',
    optional: 'اختياري',
    back: 'رجوع',
    next: 'التالي',
    submit: 'إرسال',
    clear: 'مسح',
    copy: 'نسخ',
    copied: 'تم النسخ',
    select: 'اختيار',
    chooseFile: 'اختر ملف',
    noFileChosen: 'لم يتم اختيار ملف',
    noData: 'لا توجد بيانات',
    actions: 'الإجراءات',
    status: 'الحالة',
    date: 'التاريخ',
    time: 'الوقت',
    amount: 'المبلغ',
    total: 'الإجمالي',
    quantity: 'الكمية',
    price: 'السعر',
    name: 'الاسم',
    description: 'الوصف',
    notes: 'ملاحظات',
    details: 'التفاصيل',
    by: 'بواسطة',
    from: 'من',
    to: 'إلى',
    of: 'من',
    showing: 'عرض',
    previous: 'السابق',
    items: 'العناصر',
    item: 'عنصر',
    others: 'أخرى',
    today: 'اليوم',
    yesterday: 'أمس',
    thisWeek: 'هذا الأسبوع',
    lastWeek: 'الأسبوع الماضي',
    week: 'أسبوع',
    thisMonth: 'هذا الشهر',
    lastMonth: 'الشهر الماضي',
    thisYear: 'هذا العام',
    lastYear: 'العام الماضي',
    last7Days: 'آخر 7 أيام',
    custom: 'مخصص',
    questionMark: '؟',
    deleted: 'تم المسح',
    system: 'النظام',
    product: 'منتج',
    products: 'المنتجات',
    category: 'قسم',
  },

  // Login
  login: {
    title: 'كاونتر',
    subtitle: 'تسجيل الدخول إلى حسابك',
    username: 'اسم المستخدم',
    accountNo: 'رقم الحساب',
    password: 'كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    signIn: 'تسجيل الدخول',
    noAccount: 'ليس لديك حساب؟',
    requestDemo: 'اطلب تجربة من هنا',
    signingIn: 'جاري تسجيل الدخول...',
    forgotPassword: 'نسيت كلمة المرور؟',
    invalidCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
    incorrectPassword: 'كلمة المرور غير صحيحة',
    accountDisabled: 'الحساب معطل',
    loginFailed: 'فشل تسجيل الدخول',
    failedToFetch: 'فشل في الاتصال',
    sessionConflict: 'تعارض الجلسة',
    registerLocked: 'الكاشير مقفل بواسطة موظف آخر',
    activeSessionOnOtherRegister: 'لديك جلسة نشطة على كاشير آخر',
    activeSessionOnOtherRegisterMessage: 'يرجى الذهاب إلى {register} وإغلاق جلستك قبل استخدام هذا الجهاز.',
    contactManager: 'يرجى التواصل مع المدير لحل هذه المشكلة',
    language: 'اللغة',
    english: 'English',
    arabic: 'العربية',
  },

  // Layout / Navigation
  nav: {
    pos: 'نقطة البيع',
    dashboard: 'إحصائيات',
    inventory: 'المخزون',
    offers: 'العروض',
    sessions: 'الجلسات',
    orders: 'الطلبات',
    sales: 'المبيعات',
    refunds: 'المرتجعات',
    expenses: 'المصروفات',
    purchases: 'المشتريات',
    customers: 'العملاء',
    deliveryPersonnel: 'موظفو التوصيل',
    monthlyClosing: 'الإقفال الشهري',
    audit: 'سجل العمليات',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    theme: 'المظهر',
    light: 'فاتح',
    gray: 'رمادي',
    dark: 'داكن',
    black: 'أسود',
  },

  // POS
  pos: {
    noRecordedStock: 'مخزون 0',
    cashReceivedOptionalHint: 'اتركه فارغاً إذا كان المبلغ مطابقاً',
    cart: 'السلة',
    emptyCart: 'السلة فارغة',
    scanBarcode: 'امسح الباركود...',
    searchProducts: 'البحث عن المنتجات...',
    addToCart: 'إضافة للسلة',
    removeFromCart: 'إزالة',
    clearCart: 'إفراغ السلة',
    checkout: 'الدفع',
    subtotal: 'المجموع الفرعي',
    tax: 'الضريبة',
    discount: 'الخصم',
    discountNotes: 'ملاحظات الخصم',
    discountNotesPlaceholder: 'ملاحظة اختيارية (50 حرفاً كحد أقصى)',
    discountApprovalTitle: 'الموافقة على الخصم',
    discountApprovalSubtitle: 'خصم {percent}% — الإجمالي {total}',
    discountCode: 'رمز الخصم',
    discountCodePlaceholder: 'امسح الباركود أو أدخل رمز الخصم',
    discountApprovedBy: 'تمت الموافقة بواسطة',
    completeSale: 'إتمام البيع',
    promo: 'عرض',
    grandTotal: 'الإجمالي الكلي',
    paymentMethod: 'طريقة الدفع',
    cash: 'نقدي',
    card: 'بطاقة',
    instapay: 'انستاباي',
    wallet: 'محفظة',
    mixed: 'ميكس',
    electronic: 'إلكتروني',
    cashReceived: 'المبلغ المستلم',
    change: 'الباقي',
    transactionNo: 'رقم العملية',
    processPayment: 'إتمام الدفع',
    processing: 'جاري المعالجة...',
    paymentSuccess: 'تم الدفع بنجاح',
    printReceipt: 'طباعة الفاتورة',
    newSale: 'فاتورة جديدة',
    holdOrder: 'تعليق الطلب',
    heldOrders: 'الطلبات المعلقة',
    orderMode: 'نوع الطلب',
    inStore: 'في المتجر',
    delivery: 'توصيل',
    deliveryInfo: 'معلومات التوصيل',
    customerName: 'اسم العميل',
    customerPhone: 'رقم الهاتف',
    customerAddress: 'العنوان',
    deliveryRegion: 'منطقة التوصيل',
    deliveryPerson: 'موظف التوصيل',
    deliveryPersonnelList: 'موظفو التوصيل',
    selectDeliveryPerson: 'اختر موظف التوصيل',
    deliveryFee: 'رسوم التوصيل',
    noDeliveryFee: 'بدون رسوم توصيل',
    newCustomer: 'عميل جديد - سيتم حفظ البيانات تلقائياً',
    existingCustomer: 'عميل موجود - تم ملء البيانات تلقائياً',
    clearDelivery: 'مسح',
    confirmDelivery: 'تأكيد',
    selectRegion: 'اختر المنطقة',
    noSession: 'لا توجد جلسة مفتوحة',
    openSession: 'فتح جلسة',
    closeSession: 'إغلاق الجلسة',
    sessionRequired: 'يرجى فتح جلسة للبدء في البيع',
    outOfStock: 'نفذ من المخزون',
    insufficientStock: 'المخزون غير كافي',
    availableStock: 'المتاح',
    pricePerUnit: 'السعر لكل',
    kg: 'كجم',
    pc: 'قطعة',
    pcs: 'قطع',
    units: 'وحدات',
    categories: 'الأقسام',
    allCategories: 'كل الأقسام',
    offersCategory: 'العروض',
    products: 'المنتجات',
    noProducts: 'لا توجد منتجات',
    refund: 'استرجاع',
    enterOrderUUID: 'أدخل رقم الطلب',
    electronicPayment: 'الدفع الإلكتروني',
    cashPayment: 'الدفع النقدي',
    cardPayment: 'الدفع بالبطاقة',
    instapayPayment: 'الدفع بانستاباي',
    walletPayment: 'الدفع بالمحفظة',
    mixedPayment: 'الدفع المختلط',
    totalAmount: 'المبلغ الإجمالي',
    cashReceivedEgp: 'المبلغ المستلم (ج.م)',
    paymentType: 'نوع الدفع',
    transactionNumber: 'رقم العملية',
    enterTransactionNumber: 'أدخل رقم عملية {method}',
    cashAmountEgp: 'المبلغ النقدي (ج.م)',
    mixedCashAmountHintBeforeZero: 'المبلغ يجب أن يكون أكبر من أو يساوي ',
    mixedCashAmountHintBetween: ' وأقل من ',
    secondaryPaymentMethod: 'طريقة الدفع الثانوية',
    cardAmountAuto: 'مبلغ البطاقة (ج.م) - محسوب تلقائياً',
    cardTransactionNumber: 'رقم عملية البطاقة',
    enterCardTransaction: 'أدخل رقم عملية البطاقة',
    instapayAmountAuto: 'مبلغ انستاباي (ج.م) - محسوب تلقائياً',
    instapayTransactionNumber: 'رقم عملية انستاباي',
    enterInstapayTransaction: 'أدخل رقم عملية انستاباي',
    walletAmountAuto: 'مبلغ المحفظة (ج.م) - محسوب تلقائياً',
    walletTransactionNumber: 'رقم عملية المحفظة',
    enterWalletTransaction: 'أدخل رقم عملية المحفظة',
    paymentProcessed: 'تمت معالجة الدفع',
    receiptPrinted: 'تم طباعة الفاتورة',
    saveAndCloseOrder: 'حفظ وإغلاق الطلب',
    saving: 'جاري الحفظ...',
    sessionOrders: 'طلبات الجلسة',
    sessionRefunds: 'مرتجعات الجلسة',
    noSessionOrders: 'لا توجد طلبات مطابقة للفلاتر المحددة.',
    noSessionRefunds: 'لا توجد مرتجعات في هذه الجلسة.',
    sessionOrdersLoadError: 'فشل تحميل طلبات الجلسة.',
    sessionRefundsLoadError: 'فشل تحميل مرتجعات الجلسة.',
    searchByPhone: 'ابحث برقم الهاتف',
    allPaymentMethods: 'كل طرق الدفع',
    allOrderTypes: 'كل أنواع الطلبات',
    allDeliveryPersons: 'كل مندوبي التوصيل',
    allStatuses: 'كل الحالات',
    completed: 'مكتمل',
    refunded: 'مسترجع',
    partiallyRefunded: 'مسترجع جزئياً',
  },

  // Receipt
  receipt: {
    receipt: 'فاتورة',
    receiptNo: 'رقم الفاتورة',
    transactionId: 'معرف المعاملة',
    itemsTotal: 'مجموع العناصر',
    orderNo: 'رقم الطلب',
    date: 'التاريخ',
    cashier: 'الكاشير',
    items: 'العناصر',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    tax: 'الضريبة',
    deliveryFee: 'رسوم التوصيل',
    total: 'الإجمالي',
    paymentMethod: 'طريقة الدفع',
    cashReceived: 'المبلغ المستلم',
    change: 'الباقي',
    thankYou: 'شكراً لتسوقك معنا!',
    visitAgain: 'نتطلع لزيارتك مرة أخرى',
    visitUsOn: 'زورونا على',
    refundReceipt: 'فاتورة استرجاع',
    originalOrder: 'الطلب الأصلي',
    refundedItems: 'العناصر المسترجعة',
    refundAmount: 'مبلغ الاسترجاع',
    cashAmount: 'مبلغ النقد',
    cardAmount: 'مبلغ البطاقة',
    instapayAmount: 'مبلغ انستاباي',
    walletAmount: 'مبلغ المحفظة',
    cardTransactionNo: 'رقم معاملة البطاقة',
    instapayTransactionNo: 'رقم معاملة انستاباي',
    walletTransactionNo: 'رقم معاملة المحفظة',
    refundReason: 'السبب',
    approvedBy: 'تمت الموافقة بواسطة',
    barcode: 'الباركود',
  },

  // Dashboard
  dashboard: {
    welcome: 'مرحباً',
    overview: 'نظرة عامة',
    todaySales: 'مبيعات اليوم',
    todayProfit: 'مكسب اليوم',
    todayRevenue: 'مكسب اليوم',
    totalOrders: 'إجمالي الطلبات اليوم',
    totalRevenue: 'إجمالي الإيرادات',
    averageOrder: 'متوسط الطلب',
    lowStockItems: 'منتجات منخفضة المخزون',
    recentTransactions: 'المعاملات الأخيرة',
    topSellingProducts: 'أكثر 10 منتجات مبيعاً',
    mostRefundedProducts: 'أكثر المنتجات استرجاعاً',
    revenueComparison: 'المبيعات والمكسب',
    salesByCategory: 'المبيعات حسب القسم',
    salesTrend: 'المبيعات',
    noSalesData: 'لا توجد بيانات مبيعات',
    noRefundData: 'لا توجد بيانات مرتجعات',
    period: 'الفترة',
    revenue: 'الإيرادات',
    chartProfitBarLabel: 'المكسب',
    chartSales: 'المبيعات',
    orders: 'الطلبات',
    refunds: 'المرتجعات',
    expensesChart: 'المصروفات',
    purchasesChart: 'المشتريات',
    paymentMethods: 'طرق الدفع',
    paymentSplit: 'طرق الدفع',
    refundsChart: 'المرتجعات',
    netRevenue: 'صافي الإيرادات',
    daily: 'يومي',
    weekly: 'أسبوعي',
    monthly: 'شهري',
  },

  // Inventory
  inventory: {
    adjustStock: 'تعديل المخزون',
    currentStock: 'المخزون الحالي',
    adjustBy: 'تعديل بمقدار',
    newStock: 'المخزون الجديد',
    stockCannotGoBelowZero: 'لا يمكن أن يكون المخزون أقل من 0؛ سيتم ضبطه على 0.',
    stockAdjusted: 'تم تحديث المخزون',
    oversold: 'تم البيع بالسالب',
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetInventory: 'المخزون',
      productName: 'اسم المنتج',
      sku: 'رمز المنتج',
      category: 'القسم',
      uncategorized: 'غير مصنف',
      unitType: 'نوع الوحدة',
      costPrice: 'سعر التكلفة',
      sellingPrice: 'سعر البيع',
      stock: 'المخزون',
      total: 'الإجمالي',
    },
    inventory: 'المخزون',
    inventoryManagement: 'إدارة المخزون',
    manageStock: 'إدارة المنتجات ومستويات المخزون',
    products: 'المنتجات',
    categories: 'الأقسام',
    addProduct: 'إضافة منتج',
    addItem: 'إضافة عنصر',
    editProduct: 'تعديل المنتج',
    editItem: 'تعديل العنصر',
    productDetails: 'تفاصيل المنتج',
    deleteProduct: 'حذف المنتج',
    deleteItem: 'حذف العنصر',
    productName: 'اسم المنتج',
    itemName: 'اسم العنصر',
    sku: 'رمز المنتج',
    skuAlreadyExists: 'رمز المنتج هذا موجود بالفعل',
    productNameAlreadyExists: 'منتج بهذا الاسم موجود بالفعل',
    skuOptional: 'رمز المنتج (اختياري)',
    barcode: 'الباركود',
    costPrice: 'سعر التكلفة',
    profitMargin: 'هامش الربح',
    sellingPrice: 'سعر البيع',
    salePrice: 'سعر البيع',
    stockQuantity: 'كمية المخزون',
    unitType: 'نوع الوحدة',
    piece: 'قطعة',
    perPiece: 'قطعة',
    kilogram: 'كيلوجرام',
    perKg: 'كجم',
    category: 'القسم',
    selectCategory: 'اختر القسم',
    image: 'الصورة',
    imageOptional: 'الصورة (اختياري)',
    uploadImage: 'رفع صورة',
    selectImage: 'اختر صورة',
    noImage: 'لا توجد صورة',
    invalidImage: 'صورة غير صالحة',
    enterImageUrl: 'أدخل رابط الصورة',
    imageUrlHelp: 'أدخل رابط أو ارفع صورة من جهازك',
    browse: 'تصفح',
    addCategory: 'إضافة قسم',
    addNewCategory: 'إضافة قسم جديدة',
    editCategory: 'تعديل القسم',
    deleteCategory: 'حذف القسم',
    categoryName: 'اسم القسم',
    categoryNameUnique: 'اسم هذا القسم موجود بالفعل',
    categoryColor: 'لون القسم',
    color: 'اللون',
    manageCategories: 'إدارة الأقسام',
    categoryManagement: 'إدارة الأقسام',
    noCategories: 'لا توجد أقسام بعد.',
    lowStock: 'مخزون منخفض',
    outOfStock: 'نفذ من المخزون',
    inStock: 'متوفر',
    lowStockWarning: 'عناصر منخفضة المخزون (< 10 وحدات)',
    allProducts: 'كل المنتجات',
    lowStockOnly: 'المخزون المنخفض فقط',
    andMore: 'و {count} أخرى',
    allCategories: 'كل الأقسام',
    searchProducts: 'البحث بالاسم أو الرمز...',
    noItemsFound: 'لا توجد عناصر',
    tryDifferentSearch: 'جرب بحث أو تصفية مختلفة',
    addFirstItem: 'أضف أول عنصر للبدء',
    uncategorized: 'غير مصنف',
    saving: 'جاري الحفظ...',
    confirmDeleteProduct: 'هل أنت متأكد من حذف هذا المنتج؟',
    confirmDeleteCategory: 'هل أنت متأكد من حذف هذه القسم؟',
    deleteItemConfirm: 'لا يمكن التراجع عن هذا.',
    deleteCategoryConfirm: 'سيؤثر هذا على المنتجات في هذه القسم.',
    productAdded: 'تمت إضافة المنتج بنجاح',
    productUpdated: 'تم تحديث المنتج بنجاح',
    productDeleted: 'تم حذف المنتج بنجاح',
    categoryAdded: 'تمت إضافة القسم بنجاح',
    categoryUpdated: 'تم تحديث القسم بنجاح',
    categoryDeleted: 'تم حذف القسم بنجاح',
  },

  offers: {
    pageSubtitle: 'إنشاء وإدارة عروض المنتجات المجمعة',
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetOffers: 'العروض',
      sheetComponents: 'مكونات العروض',
      offerName: 'اسم العرض',
      sku: 'رمز العرض',
      previewCost: 'إجمالي التكلفة',
      sellingPrice: 'سعر البيع',
      profitMargin: 'هامش الربح',
      status: 'الحالة',
      active: 'نشط',
      inactive: 'غير نشط',
      total: 'الإجمالي',
      productName: 'اسم المنتج',
      productSku: 'رمز المنتج',
      quantity: 'الكمية',
      unitType: 'نوع الوحدة',
      unitCost: 'سعر التكلفة',
      totalCost: 'التكلفة الإجمالية',
      noComponents: 'لا توجد مكونات',
    },
    offerName: 'اسم العرض',
    sku: 'رمز العرض',
    addOffer: 'إضافة عرض',
    editOffer: 'تعديل العرض',
    deleteOffer: 'حذف العرض',
    deleteConfirm: 'حذف "{name}"؟ ستبقى المبيعات السابقة في التقارير.',
    components: 'المكونات',
    addComponent: 'إضافة منتج',
    selectProduct: 'اختر منتجاً',
    productSearchPlaceholder: 'أدخل أو امسح الباركود أو الرمز أو اسم المنتج...',
    productNotFound: 'المنتج غير موجود',
    productAlreadyInOffer: 'هذا المنتج موجود بالفعل في العرض',
    previewCost: 'إجمالي التكلفة',
    searchOffers: 'البحث في العروض...',
    totalOffers: 'إجمالي العروض',
    activeOffers: 'نشط',
    inactiveOffers: 'غير نشط',
    noOffers: 'لا توجد عروض بعد',
    nameRequired: 'اسم العرض مطلوب',
    nameMaxLength: 'اسم العرض يجب ألا يتجاوز 35 حرفاً',
    sellingPriceRequired: 'سعر البيع يجب أن يكون أكبر من صفر',
    componentsRequired: 'أضف منتجاً واحداً على الأقل للعرض',
    skuAlreadyExists: 'رمز العرض هذا موجود بالفعل',
    created: 'تم إنشاء العرض بنجاح',
    updated: 'تم تحديث العرض بنجاح',
    deleted: 'تم حذف العرض بنجاح',
    deactivatedOnDelete: 'تم إيقاف العرض (له مبيعات سابقة)',
    activated: 'تم تفعيل العرض بنجاح',
    deactivatedStatus: 'تم إيقاف العرض بنجاح',
    activate: 'تفعيل',
    deactivate: 'إيقاف',
    activeOffer: 'نشط (يظهر في نقطة البيع)',
    viewOffer: 'عرض التفاصيل',
    offerDetails: 'تفاصيل العرض',
    noComponents: 'لا توجد منتجات في هذا العرض',
    lineCost: 'التكلفة الإجمالية',
    categoryName: 'العروض',
  },

  // Expenses
  expenses: {
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetCategories: 'الأقسام',
      sheetExpenses: 'المصروفات',
      name: 'الاسم',
      category: 'القسم',
      uncategorized: 'غير مصنف',
      date: 'التاريخ',
      amount: 'المبلغ',
      total: 'الإجمالي',
    },
    title: 'المصروفات',
    subtitle: 'تتبع وإدارة مصروفات العمل',
    addExpense: 'إضافة مصروف',
    editExpense: 'تعديل المصروف',
    deleteExpense: 'حذف المصروف',
    expenseName: 'اسم المصروف',
    amount: 'المبلغ',
    category: 'القسم',
    selectCategory: 'اختر القسم',
    date: 'التاريخ',
    totalExpenses: 'إجمالي المصروفات',
    thisMonth: 'هذا الشهر',
    expenseCount: 'عدد المصروفات',
    manageCategories: 'إدارة الأقسام',
    addCategory: 'إضافة قسم',
    editCategory: 'تعديل القسم',
    deleteCategory: 'حذف القسم',
    categoryName: 'اسم القسم',
    categoryNameUnique: 'اسم هذا القسم موجود بالفعل',
    noCategories: 'لا توجد أقسام مصروفات بعد.',
    noExpenses: 'لا توجد مصروفات',
    tryDifferentFilters: 'جرب فلاتر أو نطاق تاريخ مختلف',
    addFirstExpense: 'أضف أول مصروف للبدء',
    searchPlaceholder: 'البحث بالاسم...',
    deleteExpenseConfirm: 'لا يمكن التراجع عن هذا.',
    deleteCategoryConfirm: 'حذف "{name}"؟ سيتم حذف جميع المصروفات في هذه القسم.',
    nameRequired: 'اسم المصروف مطلوب',
    categoryRequired: 'يرجى اختيار قسم',
    invalidAmount: 'المبلغ يجب أن يكون أكبر من 0',
  },

  purchases: {
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetCategories: 'الأقسام',
      sheetPurchases: 'المشتريات',
      totalPurchasesByCategory: 'إجمالي المشتريات',
      productName: 'اسم المنتج',
      category: 'القسم',
      uncategorized: 'غير مصنف',
      unitType: 'نوع الوحدة',
      supplier: 'المورد',
      date: 'التاريخ',
      quantity: 'الكمية',
      unitPrice: 'سعر الوحدة',
      unitSellingPrice: 'سعر البيع للوحدة',
      oldCostPrice: 'سعر التكلفة السابق',
      oldSellingPrice: 'سعر البيع السابق',
      inventoryBefore: 'المخزون قبل',
      inventoryAfter: 'المخزون بعد',
      totalPrice: 'السعر الإجمالي',
      total: 'الإجمالي',
    },
    title: 'المشتريات',
    subtitle: 'تتبع مشتريات المخزون والموردين',
    addPurchase: 'إضافة مشتريات',
    editPurchase: 'تعديل المشتريات',
    deletePurchase: 'حذف المشتريات',
    deletePurchaseConfirm: 'حذف مشتريات {quantity} × "{product}"؟ سيتم تخفيض المخزون. لا يمكن التراجع عن ذلك.',
    manageSuppliers: 'إدارة الموردين',
    barcodePlaceholder: 'أدخل أو امسح الباركود أو الرمز أو اسم المنتج...',
    supplier: 'المورد',
    selectSupplier: 'اختر المورد',
    costPrice: 'سعر التكلفة',
    sellingPrice: 'سعر البيع',
    quantity: 'الكمية',
    quantityHintPiece: 'أرقام صحيحة فقط — هذا المنتج يُحسب بالقطعة.',
    quantityHintKg: 'حتى 3 خانات عشرية كحد أقصى — هذا المنتج يُحسب بالكيلو.',
    inventoryBeforeAfter: 'المخزون الجديد: {before} + {quantity} = {after}',
    date: 'التاريخ',
    totalPurchases: 'إجمالي المشتريات',
    purchaseCount: 'عدد المشتريات',
    todayPurchases: 'مشتريات اليوم',
    todayTotal: 'إجمالي اليوم',
    noPurchases: 'لا توجد مشتريات',
    tryDifferentFilters: 'جرب فلاتر أو نطاق تاريخ مختلف',
    addFirstPurchase: 'أضف أول عملية شراء للبدء',
    searchPlaceholder: 'البحث بالمنتج أو الرمز...',
    productNotFound: 'المنتج غير موجود',
    changeProduct: 'تغيير',
    supplierName: 'اسم المورد',
    supplierPhone: 'الهاتف',
    addSupplier: 'إضافة مورد',
    editSupplier: 'تعديل المورد',
    deleteSupplier: 'حذف المورد',
    deleteSupplierConfirm: 'حذف "{name}"؟ لا يمكن التراجع عن ذلك.',
    supplierHasPurchases: 'لا يمكن حذف مورد لديه مشتريات',
    supplierPhoneUnique: 'هذا الرقم موجود بالفعل',
    supplierNameUnique: 'يوجد مورد بنفس الاسم بالفعل',
    noSuppliers: 'لا يوجد موردون بعد. أضف مورداً أولاً.',
    searchSuppliersPlaceholder: 'البحث بالاسم أو الهاتف…',
    suppliersNoSearchMatches: 'لا يوجد موردون يطابقون البحث.',
    purchaseDetails: 'تفاصيل المشتريات',
    productData: 'بيانات المنتج',
    supplierData: 'بيانات المورد',
    purchaseSummary: 'ملخص المشتريات',
    oldCostPrice: 'سعر التكلفة السابق',
    oldSellingPrice: 'سعر البيع السابق',
    oldInventory: 'المخزون السابق',
    newInventory: 'المخزون الجديد',
  },

  monthlyClosing: {
    title: 'الإقفال الشهري',
    subtitle: 'حساب وحفظ إجماليات المصروفات والمبيعات والمشتريات الشهرية',
    closingDate: 'تاريخ الإقفال',
    calculateAndSave: 'حساب وحفظ',
    startDate: 'تاريخ البداية',
    startDateOptionalHint: 'اتركه فارغًا ليُحسب تلقائيًا من تاريخ الإقفال (نافذة شهر واحد قبله بما في ذلك).',
    startDateAfterClosing: 'تاريخ البداية يجب أن يكون في أو قبل تاريخ الإقفال.',
    totalExpenses: 'إجمالي المصروفات',
    totalSales: 'إجمالي المبيعات',
    totalPurchases: 'إجمالي المشتريات',
    totalSalesRevenue: 'إجمالي المكسب',
    totalRefunds: 'إجمالي المرتجعات',
    pastClosings: 'الإقفالات السابقة',
    noClosings: 'لا توجد إقفالات شهرية بعد. أدخل تاريخ الإقفال واضغط حساب وحفظ.',
    loadFailed: 'فشل تحميل الإقفالات الشهرية',
    saveFailed: 'فشل حفظ الإقفال الشهري',
    closingDateRequired: 'تاريخ الإقفال مطلوب',
    alreadyExists: 'يوجد بالفعل إقفال لنفس الفترة (من تاريخ البداية إلى تاريخ الإقفال).',
    deleteConfirm: 'حذف الإقفال الشهري لـ {date}؟',
    deleteFailed: 'فشل حذف الإقفال الشهري',
    download: 'تحميل Excel',
    downloading: 'جاري التحميل...',
    downloadFailed: 'فشل تحميل التصدير',
    excelExport: {
      sheetSummary: 'الملخص',
      sheetSales: 'المبيعات',
      sheetPurchases: 'المشتريات',
      sheetExpenses: 'المصروفات',
      sheetRefunds: 'المرتجعات',
      sheetInventory: 'المخزون',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      closingDate: 'تاريخ الإقفال',
      totalExpenses: 'إجمالي المصروفات',
      totalSales: 'إجمالي المبيعات',
      totalPurchases: 'إجمالي المشتريات',
      totalRefunds: 'إجمالي المرتجعات',
      totalPurchasesByCategory: 'إجمالي المشتريات',
      totalRevenueProfit: 'إجمالي المكسب',
      productName: 'اسم المنتج',
      sku: 'رمز المنتج',
      category: 'القسم',
      uncategorized: 'غير مصنف',
      offerCategory: 'عرض',
      unitType: 'نوع الوحدة',
      soldQty: 'الكمية المباعة',
      revenue: 'المبيعات',
      revenueProfit: 'المكسب',
      productCode: 'كود المنتج',
      supplier: 'المورد',
      quantity: 'الكمية',
      unitPrice: 'سعر الوحدة',
      unitSellingPrice: 'سعر البيع للوحدة',
      oldCostPrice: 'سعر التكلفة السابق',
      oldSellingPrice: 'سعر البيع السابق',
      inventoryBefore: 'المخزون قبل',
      inventoryAfter: 'المخزون بعد',
      totalPrice: 'السعر الإجمالي',
      date: 'التاريخ',
      name: 'الاسم',
      code: 'الكود',
      amount: 'المبلغ',
      costPrice: 'سعر التكلفة',
      sellingPrice: 'سعر البيع',
      stock: 'المخزون',
      total: 'الإجمالي',
      refundedQty: 'الكمية المستردة',
      refundedAmount: 'المبلغ المسترد',
      refundProductCategory: 'قسم المنتج',
    },
  },

  // Customers
  customers: {
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetCustomers: 'العملاء',
      name: 'الاسم',
      phone: 'الهاتف',
      address: 'العنوان',
      totalOrders: 'إجمالي الطلبات',
      totalSpent: 'إجمالي المشتريات',
      total: 'الإجمالي',
    },
    title: 'العملاء',
    subtitle: 'عرض وإدارة معلومات العملاء',
    addCustomer: 'إضافة عميل',
    editCustomer: 'تعديل العميل',
    customerDetails: 'تفاصيل العميل',
    totalOrders: 'إجمالي الطلبات',
    totalPurchases: 'إجمالي المشتريات',
    noCustomers: 'لا يوجد عملاء',
    tryDifferentSearch: 'جرب بحثاً مختلفاً',
    addFirstCustomer: 'أضف أول عميل أو سيظهرون عند تنفيذ الطلبات',
    searchPlaceholder: 'البحث بالاسم أو الهاتف...',
    nameRequired: 'اسم العميل مطلوب',
    phoneRequired: 'رقم الهاتف مطلوب',
    phoneUnique: 'هذا الرقم موجود بالفعل',
    deleteCustomer: 'حذف العميل',
    deleteCustomerConfirm: 'حذف "{name}"؟ لا يمكن التراجع عن هذا. سيتم إلغاء ربط الطلبات بهذا العميل.',
  },

  deliveryPersons: {
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetDelivery: 'موظفو التوصيل',
      name: 'الاسم',
      phone: 'الهاتف',
      total: 'الإجمالي',
    },
    title: 'موظفو التوصيل',
    subtitle: 'إدارة موظفي التوصيل لطلبات التوصيل',
    addPerson: 'إضافة موظف توصيل',
    editPerson: 'تعديل موظف التوصيل',
    deletePerson: 'حذف موظف التوصيل',
    addFirstPerson: 'أضف موظفي التوصيل لتعيينهم لطلبات التوصيل في نقطة البيع.',
    searchPlaceholder: 'البحث بالاسم أو الهاتف...',
    noResults: 'لا يوجد موظفو توصيل',
    tryDifferentSearch: 'جرب بحثاً مختلفاً',
  },

  // Sessions
  sessions: {
    downloadExcel: 'تحميل Excel',
    searchBySessionNo: 'البحث برقم الجلسة...',
    excelExport: {
      sheetSessions: 'الجلسات',
      cashier: 'الكاشير',
      register: 'الجهاز',
      startTime: 'وقت البدء',
      endTime: 'وقت الانتهاء',
      status: 'الحالة',
      openingCash: 'النقدية الافتتاحية',
      expectedCash: 'النقدية المتوقعة',
      expectedCard: 'البطاقة المتوقعة',
      expectedInstapay: 'انستاباي المتوقع',
      expectedWallet: 'المحفظة المتوقعة',
      refundAmount: 'مبلغ الاسترجاع',
      receivedCash: 'النقدية المستلمة',
      cashDiff: 'فرق النقدية',
      closedBy: 'أُغلقت بواسطة',
      reviewedBy: 'تمت المراجعة بواسطة',
      total: 'الإجمالي',
    },
    sessions: 'الجلسات',
    currentSession: 'الجلسة الحالية',
    openSession: 'فتح جلسة',
    closeSession: 'إغلاق الجلسة',
    viewSession: 'عرض الجلسة',
    sessionDetails: 'تفاصيل الجلسة',
    openingCash: 'النقدية الافتتاحية',
    openingCard: 'رصيد البطاقة الافتتاحي',
    closingCash: 'النقدية المستلمة',
    netCash: 'صافي النقدية',
    closingCard: 'البطاقة الختامية',
    closingInstapay: 'انستاباي الختامي',
    closingWallet: 'المحفظة الختامية',
    expectedCash: 'النقدية المتوقعة',
    expectedCard: 'البطاقة المتوقعة',
    expectedInstapay: 'انستاباي المتوقع',
    expectedWallet: 'المحفظة المتوقعة',
    difference: 'الفرق',
    cashDifference: 'فرق النقدية',
    cardDifference: 'فرق البطاقة',
    instapayDifference: 'فرق انستاباي',
    walletDifference: 'فرق المحفظة',
    totalSales: 'إجمالي المبيعات',
    totalRefunds: 'إجمالي المرتجعات',
    netSales: 'صافي المبيعات',
    startTime: 'وقت البدء',
    endTime: 'وقت الانتهاء',
    duration: 'المدة',
    cashier: 'الكاشير',
    register: 'الجهاز',
    status: 'الحالة',
    open: 'مفتوحة',
    closed: 'مغلقة',
    forceClosed: 'مغلقة قسراً',
    reviewed: 'تمت المراجعة',
    notes: 'ملاحظات',
    closingNotes: 'ملاحظات الإغلاق',
    reviewNotes: 'ملاحظات المراجعة',
    reviewedBy: 'تمت المراجعة بواسطة',
    reviewSession: 'مراجعة الجلسة',
    forceClose: 'إغلاق إجباري',
    confirmForceClose: 'هل أنت متأكد من الإغلاق الإجباري لهذه الجلسة؟',
    sessionOpened: 'تم فتح الجلسة بنجاح',
    sessionClosed: 'تم إغلاق الجلسة بنجاح',
    openSessionSubtitle: 'أدخل النقدية الافتتاحية ',
    openingCashLabel: 'النقدية الافتتاحية (جنيه)',
    openingSessionInProgress: 'جاري فتح الجلسة…',
    loadingSession: 'جاري تحميل الجلسة...',
    registerLocked: 'الكاشير مقفل',
    registerLockedMessage: 'هذا الجهاز لديه جلسة نشطة',
    registerLockedFullMessage: '{name} لديه جلسة نشطة على هذا الجهاز. يجب عليه تسجيل الدخول وإغلاقها، أو يقوم المدير أو المشرف بإغلاقها إجبارياً.',
    registerLockedOptions: 'الخيارات:',
    registerLockedOption1: 'يجب تسجيل الدخول وإغلاق جلسته',
    registerLockedOption2: 'يجب على المدير أو المشرف إغلاق الجلسة إجبارياً',
    startedAt: 'البدء',
    closingCashLabel: 'النقدية المستلمة (جنيه)',
    closingSessionInProgress: 'جاري الإغلاق...',
    opening: 'الافتتاح:',
    allCashiers: 'كل الكاشيرين',
    allRegisters: 'كل الأجهزة',
    allStatuses: 'كل الحالات',
    filterByDate: 'تصفية حسب التاريخ',
    filterByCashier: 'تصفية حسب الكاشير',
    filterByRegister: 'تصفية حسب الجهاز',
    filterByStatus: 'تصفية حسب الحالة',
    sessionClosingReceipt: 'إيصال إغلاق الجلسة',
    sessionNo: 'رقم الجلسة',
    sessionId: 'معرف الجلسة',
    openingBalance: 'الرصيد الافتتاحي',
    openingCardAt: 'رصيد البطاقة الافتتاحي (عند)',
    closingBalance: 'الرصيد الختامي',
    closingCardAt: 'البطاقة الختامية (عند)',
    closingCardNet: 'البطاقة الختامية (صافي)',
    expectedClosing: 'الإغلاق المتوقع',
    sales: 'المبيعات',
    expectedCashFormula: 'النقدية المتوقعة: الافتتاح + المبيعات - الاسترجاع',
    expectedCashReceipt: 'النقدية المتوقعة: {amount}'
  },

  // Reports / Orders
  reports: {
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetOrdersInStore: 'طلبات في المتجر',
      sheetOrdersDelivery: 'طلبات التوصيل',
      receiptNo: 'رقم الفاتورة',
      date: 'التاريخ',
      customer: 'العميل',
      deliveryRegion: 'منطقة التوصيل',
      deliveryPerson: 'موظف التوصيل',
      cashier: 'الكاشير',
      paymentMethod: 'طريقة الدفع',
      promoName: 'اسم العرض',
      promoPercentage: 'نسبة العرض %',
      discountApprover: 'معتمد الخصم',
      discount: 'الخصم',
      tax: 'الضريبة',
      total: 'الإجمالي',
      status: 'الحالة',
      discountNotes: 'ملاحظات الخصم',
      grandTotal: 'الإجمالي الكلي',
    },
    orders: 'الطلبات',
    sales: 'المبيعات',
    salesReport: 'تقرير المبيعات',
    orderDetails: 'تفاصيل الطلب',
    orderNo: 'رقم الطلب',
    receiptNo: 'رقم الفاتورة',
    orderDate: 'تاريخ الطلب',
    customer: 'العميل',
    walkIn: 'عميل عابر',
    paymentMethod: 'طريقة الدفع',
    totalAmount: 'المبلغ الإجمالي',
    status: 'الحالة',
    completed: 'مكتمل',
    refunded: 'مسترجع',
    partiallyRefunded: 'مسترجع جزئياً',
    viewOrder: 'عرض الطلب',
    printReceipt: 'طباعة الفاتورة',
    filterByDate: 'تصفية حسب التاريخ',
    filterByPayment: 'تصفية حسب الدفع',
    filterByStatus: 'تصفية حسب الحالة',
    allPaymentMethods: 'كل طرق الدفع',
    allStatuses: 'كل الحالات',
    totalSales: 'إجمالي المبيعات',
    totalOrders: 'إجمالي الطلبات',
    averageOrder: 'متوسط الطلب',
    searchByUUID: 'البحث برقم الطلب...',
    searchByPhone: 'البحث بالهاتف...',
    searchOrders: 'ابحث برقم الإيصال أو الهاتف أو رقم الجلسة...',
    noOrders: 'لا توجد طلبات',
    orderItems: 'عناصر الطلب',
    paymentDetails: 'تفاصيل الدفع',
    orderType: 'نوع الطلب',
    session: 'الجلسة',
    discount: 'الخصم',
    withDiscount: 'به خصم',
    withoutDiscount: 'بدون خصم',
  },

  // Sales (product sold quantities)
  sales: {
    title: 'المبيعات',
    byProduct: 'حسب المنتج',
    byOffer: 'حسب العرض',
    offerName: 'اسم العرض',
    bundlesSold: 'العروض المباعة',
    searchOffer: 'بحث عن عرض...',
    totalUnitsSold: 'إجمالي الوحدات المباعة',
    totalRevenue: 'إجمالي المبيعات',
    soldQuantity: 'الكمية المباعة',
    revenue: 'المبيعات',
    revenueProfit: 'المكسب',
    searchProduct: 'بحث عن منتج',
    noSalesData: 'لا توجد بيانات مبيعات للفترة المحددة',
    downloadExcel: 'تحميل',
    excelExport: {
      sheetSummary: 'الأقسام',
      sheetSales: 'المبيعات',
      sheetOfferSales: 'مبيعات العروض',
      offerName: 'اسم العرض',
      bundlesSold: 'العروض المباعة',
      productName: 'اسم المنتج',
      productCode: 'كود المنتج',
      sku: 'رمز المنتج',
      category: 'القسم',
      uncategorized: 'غير مصنف',
      unitType: 'نوع الوحدة',
      soldQty: 'الكمية المباعة',
      revenue: 'المبيعات',
      revenueProfit: 'المكسب',
      total: 'الإجمالي',
    },
  },

  // Refunds
  refunds: {
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetRefunds: 'المرتجعات',
      receiptNo: 'رقم الفاتورة',
      date: 'التاريخ',
      orderCashier: 'كاشير الطلب',
      refundCashier: 'تم الارجاع بواسطة',
      cashier: 'الكاشير',
      approvedBy: 'تمت الموافقة بواسطة',
      reason: 'السبب',
      amount: 'المبلغ',
      status: 'الحالة',
      totalRefunded: 'إجمالي المرتجعات',
    },
    refunds: 'المرتجعات',
    refundList: 'قائمة المرتجعات',
    newRefund: 'استرجاع جديد',
    refundDetails: 'تفاصيل الاسترجاع',
    refundNo: 'رقم الاسترجاع',
    originalOrder: 'الطلب الأصلي',
    refundDate: 'تاريخ الاسترجاع',
    refundAmount: 'مبلغ الاسترجاع',
    refundReason: 'السبب',
    approvedBy: 'تمت الموافقة بواسطة',
    processedBy: 'تمت المعالجة بواسطة',
    orderCashier: 'كاشير الطلب',
    refundCashier: 'تم الارجاع بواسطة',
    refundedItems: 'العناصر المسترجعة',
    selectItems: 'اختر العناصر للاسترجاع',
    refundQuantity: 'كمية الاسترجاع',
    restock: 'إعادة للمخزون',
    restockItem: 'إعادة العنصر للمخزون',
    processRefund: 'معالجة الاسترجاع',
    confirmRefund: 'تأكيد الاسترجاع',
    refundSuccess: 'تم الاسترجاع بنجاح',
    enterReason: 'أدخل سبب الاسترجاع',
    reasonRequired: 'السبب مطلوب',
    noItemsSelected: 'لم يتم اختيار عناصر للاسترجاع',
    refundQuantityRequired: 'يرجى إدخال كمية استرجاع أكبر من صفر',
    maxRefundExceeded: 'مبلغ الاسترجاع يتجاوز الحد المسموح',
    searchByOrderUUID: 'البحث برقم الطلب...',
    searchByReceiptNo: 'البحث برقم الفاتورة...',
    filterByDate: 'تصفية حسب التاريخ',
    noRefunds: 'لا توجد مرتجعات',
    totalRefundedAmount: 'إجمالي المرتجعات (جنيه)',
    totalRefunded: 'إجمالي المرتجعات',
    fullRefund: 'استرجاع كامل',
    partialRefund: 'استرجاع جزئي',
    statusRejected: 'مرفوض',
    statusPending: 'قيد الانتظار',
    discountedOrder: 'طلب بخصم',
    refundCodeOrUuid: 'رمز الاسترجاع',
    refundCodeOrUuidPlaceholder: 'امسح الباركود أو أدخل رمز الاسترجاع',
    todayTotalLabel: 'إجمالي اليوم',
    monthTotalLabel: 'إجمالي الشهر',
  },

  // Audit
  audit: {
    downloadExcel: 'تحميل Excel',
    excelExport: {
      sheetAudit: 'سجل العمليات',
      dateTime: 'التاريخ/الوقت',
      user: 'المستخدم',
      role: 'الوظيفة',
      action: 'الإجراء',
      entityType: 'نوع الوحدة',
      entityId: 'معرف الوحدة',
    },
    auditLog: 'سجل العمليات',
    auditTrail: 'مسار العمليات',
    action: 'الإجراء',
    actor: 'المنفذ',
    entityType: 'نوع الوحدة',
    entityId: 'معرف الوحدة',
    timestamp: 'الوقت',
    details: 'التفاصيل',
    oldValue: 'القيمة القديمة',
    newValue: 'القيمة الجديدة',
    viewDetails: 'عرض التفاصيل',
    view: 'عرض',
    filterByAction: 'تصفية حسب الإجراء',
    filterByActor: 'تصفية حسب المنفذ',
    filterByEntity: 'تصفية حسب الوحدة',
    allActions: 'كل الإجراءات',
    allActors: 'كل المنفذين',
    allEntities: 'كل الوحدةات',
    noAuditLogs: 'لا توجد سجلات تدقيق',
    // Action types
    orderRefunded: 'تم استرجاع الطلب',
    orderPartiallyRefunded: 'تم استرجاع الطلب جزئياً',
    productCreated: 'تم إنشاء المنتج',
    productUpdated: 'تم تحديث المنتج',
    productDeleted: 'تم حذف المنتج',
    sessionOpened: 'تم فتح الجلسة',
    sessionClosed: 'تم إغلاق الجلسة',
    sessionForceClosed: 'تم إغلاق الجلسة إجبارياً',
    categoryCreated: 'تم إنشاء القسم',
    categoryUpdated: 'تم تحديث القسم',
    categoryDeleted: 'تم حذف القسم',
    offerCreated: 'تم إنشاء العرض',
    offerUpdated: 'تم تحديث العرض',
    offerDeleted: 'تم حذف العرض',
    expenseCreated: 'تم إنشاء المصروف',
    expenseUpdated: 'تم تحديث المصروف',
    expenseDeleted: 'تم حذف المصروف',
    expenseCategoryCreated: 'تم إنشاء قسم المصروف',
    expenseCategoryUpdated: 'تم تحديث قسم المصروف',
    expenseCategoryDeleted: 'تم حذف قسم المصروف',
    purchaseCreated: 'تم إنشاء المشتريات',
    purchaseUpdated: 'تم تحديث المشتريات',
    purchaseDeleted: 'تم حذف المشتريات',
    supplierCreated: 'تم إنشاء المورد',
    supplierUpdated: 'تم تحديث المورد',
    supplierDeleted: 'تم حذف المورد',
    storeDataUpdated: 'تم تحديث بيانات المتجر',
    userCreated: 'تم إنشاء مستخدم',
    userUpdated: 'تم تحديث مستخدم',
    userDeleted: 'تم حذف مستخدم',
    userRefundCodeRenewed: 'تم تجديد الكود',
    userAudit: {
      accountCreated: 'تم إنشاء الحساب',
      accountUpdated: 'تم تحديث الحساب',
      accountDeactivated: 'تم تعطيل الحساب',
      accountDeleted: 'تم حذف الحساب',
      changes: 'التغييرات',
      passwordReset: 'تم إعادة تعيين كلمة المرور',
    },
    storeAudit: {
      settingsUpdated: 'تم تحديث الإعدادات',
      changes: 'التغييرات',
      logoUpdated: 'تم تحديث الشعار',
    },
    offerAudit: {
      before: 'قبل',
      after: 'بعد',
    },
    allTypes: 'كل الأنواع',
    // Entity types
    entityOrder: 'الطلب',
    entityProduct: 'المنتج',
    entitySession: 'الجلسة',
    entityRefund: 'الاسترجاع',
    entityCategory: 'القسم',
    entityExpense: 'المصروف',
    entityExpenseCategory: 'قسم المصروف',
    entityPurchase: 'المشتريات',
    entitySupplier: 'المورد',
    entityStoreData: 'بيانات المتجر',
    entityUser: 'مستخدم',
    roleAdmin: 'مدير',
    roleOwner: 'المالك',
    roleManager: 'مشرف',
    roleCashier: 'كاشير',
    whatHappened: 'ماذا حدث',
    whatChanged: 'ما الذي تغير',
    noChangesDetected: 'لم يتم اكتشاف تغييرات',
    additionalInfo: 'معلومات إضافية',
    setTo: 'تم تعيينه إلى',
    actionRecorded: 'تم تسجيل الإجراء بنجاح',
    // Human-readable summaries
    summary: {
      productCreated: '{actor} أضاف منتج جديد: {name}',
      productUpdated: '{actor} حدّث المنتج: {name}',
      productDeleted: '{actor} حذف المنتج: {name}',
      sessionOpened: '{actor} فتح جلسة جديدة {amount}',
      sessionClosed: '{actor} أغلق الجلسة {sales}',
      sessionForceClosed: '{actor} أغلق الجلسة إجبارياً',
      orderRefunded: '{actor} استرجع طلب {amount}',
      orderPartiallyRefunded: '{actor} استرجع طلب جزئياً {amount}',
      categoryCreated: '{actor} أنشأ قسم: {name}',
      categoryUpdated: '{actor} حدّث قسم: {name}',
      categoryDeleted: '{actor} حذف قسم: {name}',
      offerCreated: '{actor} أنشأ عرض: {name}',
      offerUpdated: '{actor} حدّث عرض: {name}',
      offerDeleted: '{actor} حذف عرض: {name}',
      expenseCreated: '{actor} أضاف مصروف {amount}',
      expenseUpdated: '{actor} حدّث مصروف',
      expenseDeleted: '{actor} حذف مصروف',
      expenseCategoryCreated: '{actor} أنشأ قسم مصروف: {name}',
      expenseCategoryUpdated: '{actor} حدّث قسم مصروف: {name}',
      expenseCategoryDeleted: '{actor} حذف قسم مصروف: {name}',
      purchaseCreated: '{actor} سجّل مشتريات {amount}',
      purchaseUpdated: '{actor} حدّث مشتريات',
      purchaseDeleted: '{actor} حذف مشتريات',
      supplierCreated: '{actor} أضاف مورد: {name}',
      supplierUpdated: '{actor} حدّث مورد: {name}',
      supplierDeleted: '{actor} حذف مورد: {name}',
      storeDataUpdated: '{actor} حدّث إعدادات المتجر',
      userCreated: '{actor} أنشأ مستخدم: {name}',
      userUpdated: '{actor} حدّث مستخدم: {name}',
      userDeleted: '{actor} حذف مستخدم: {name}',
      userRefundCodeRenewed: '{actor} جدّد الكود لـ: {name}',
      userDeactivated: '{actor} عطّل مستخدم: {name}',
      userReactivated: '{actor} أعاد تفعيل مستخدم: {name}',
      userPasswordReset: '{actor} أعاد تعيين كلمة مرور: {name}',
      default: '{actor} نفّذ: {action}',
    },
    summaryNoActor: {
      productCreated: 'أضاف منتج جديد: {name}',
      productUpdated: 'حدّث المنتج: {name}',
      productDeleted: 'حذف المنتج: {name}',
      sessionOpened: 'فتح جلسة جديدة {amount}',
      sessionClosed: 'أغلق الجلسة {sales}',
      sessionForceClosed: 'أغلق الجلسة إجبارياً',
      orderRefunded: 'استرجع طلب {amount}',
      orderPartiallyRefunded: 'استرجع طلب جزئياً {amount}',
      categoryCreated: 'أنشأ قسم: {name}',
      categoryUpdated: 'حدّث قسم: {name}',
      categoryDeleted: 'حذف قسم: {name}',
      offerCreated: 'أنشأ عرض: {name}',
      offerUpdated: 'حدّث عرض: {name}',
      offerDeleted: 'حذف عرض: {name}',
      expenseCreated: 'أضاف مصروف {amount}',
      expenseUpdated: 'حدّث مصروف',
      expenseDeleted: 'حذف مصروف',
      expenseCategoryCreated: 'أنشأ قسم مصروف: {name}',
      expenseCategoryUpdated: 'حدّث قسم مصروف: {name}',
      expenseCategoryDeleted: 'حذف قسم مصروف: {name}',
      purchaseCreated: 'سجّل مشتريات {amount}',
      purchaseUpdated: 'حدّث مشتريات',
      purchaseDeleted: 'حذف مشتريات',
      supplierCreated: 'أضاف مورد: {name}',
      supplierUpdated: 'حدّث مورد: {name}',
      supplierDeleted: 'حذف مورد: {name}',
      storeDataUpdated: 'حدّث إعدادات المتجر',
      userCreated: 'أنشأ مستخدم: {name}',
      userUpdated: 'حدّث مستخدم: {name}',
      userDeleted: 'حذف مستخدم: {name}',
      userRefundCodeRenewed: 'جدّد الكود لـ: {name}',
      userDeactivated: 'عطّل مستخدم: {name}',
      userReactivated: 'أعاد تفعيل مستخدم: {name}',
      userPasswordReset: 'أعاد تعيين كلمة مرور: {name}',
    },
    // Change descriptions
    changeAdded: 'أُضيف {field}: {value}',
    changeRemoved: 'أُزيل {field}: {value}',
    changeUpdated: 'تغيّر {field} من {oldValue} إلى {newValue}',
    storeChange: {
      promoRemoved: 'تم حذف العرض الترويجي',
      promoRemovedDetail: 'تم حذف العرض الترويجي: {value}',
      promoAdded: 'تمت إضافة عرض ترويجي',
      promoAddedDetail: 'تمت إضافة عرض ترويجي: {value}',
      phoneNumbersRemoved: 'تم حذف أرقام الهاتف',
      phoneNumbersRemovedDetail: 'تم حذف أرقام الهاتف: {value}',
      phoneNumbersAdded: 'تمت إضافة أرقام الهاتف',
      phoneNumbersAddedDetail: 'تمت إضافة أرقام الهاتف: {value}',
      socialMediaRemoved: 'تم حذف روابط التواصل الاجتماعي',
      socialMediaRemovedDetail: 'تم حذف روابط التواصل الاجتماعي: {value}',
      socialMediaAdded: 'تمت إضافة روابط التواصل الاجتماعي',
      socialMediaAddedDetail: 'تمت إضافة روابط التواصل الاجتماعي: {value}',
      deliveryFeeRemoved: 'تم حذف مناطق التوصيل',
      deliveryFeeRemovedDetail: 'تم حذف مناطق التوصيل: {value}',
      deliveryFeeAdded: 'تمت إضافة مناطق التوصيل',
      deliveryFeeAddedDetail: 'تمت إضافة مناطق التوصيل: {value}',
      itemAdded: 'تمت الإضافة',
      itemRemoved: 'تم الحذف',
      itemUpdated: 'تم التحديث',
      onReceipt: 'على الإيصال',
    },
    fields: {
      name: 'الاسم',
      full_name: 'الاسم الكامل',
      username: 'اسم المستخدم',
      role: 'الوظيفة',
      is_active: 'الحالة',
      product_name: 'اسم المنتج',
      sku: 'رمز المنتج',
      barcode: 'الباركود',
      cost_price: 'سعر التكلفة',
      selling_price: 'سعر البيع',
      stock_quantity: 'كمية المخزون',
      category_id: 'القسم',
      image_url: 'رابط الصورة',
      category_name: 'اسم القسم',
      color: 'اللون',
      amount: 'المبلغ',
      date: 'التاريخ',
      notes: 'ملاحظات',
      profit: 'الربح',
      order_total: 'إجمالي الطلب',
      tax_amount: 'قيمة الضريبة',
      discount_amount: 'قيمة الخصم',
      payment_method: 'طريقة الدفع',
      opening_cash: 'النقدية الافتتاحية',
      closing_cash: 'النقدية الختامية',
      status: 'الحالة',
      supplier_name: 'اسم المورد',
      supplier_phone: 'هاتف المورد',
      details: 'التفاصيل',
      old_value: 'القيمة القديمة',
      new_value: 'القيمة الجديدة',
      store_name: 'اسم المتجر',
      address: 'العنوان',
      phone1: 'هاتف 1',
      phone2: 'هاتف 2',
      phone3: 'هاتف 3',
      website: 'الموقع الإلكتروني',
      low_stock_threshold: 'حد المخزون المنخفض',
      tax: 'الضريبة',
      receipt_footer: 'رسالة أسفل الفاتورة',
      phone_numbers: 'أرقام الهاتف',
      social_media_urls: 'وسائل التواصل',
      delivery_fee: 'رسوم التوصيل',
      include_delivery_fee: 'تضمين رسوم التوصيل',
      logo_path: 'شعار المتجر',
      logo_size: 'حجم الشعار',
      refund_period: 'فترة الاسترجاع (أيام)',
      requires_ref_num: 'يتطلب رقم مرجعي',
      discount_requires_approval: 'الخصم يتطلب موافقة',
      promo: 'عرض ترويجي',
      password_changed: 'تم تغيير كلمة المرور',
    },
  },

  // Settings
  settings: {
    settings: 'الإعدادات',
    general: 'عام',
    storeSettings: 'إعدادات المتجر',
    storeInformation: 'معلومات المتجر',
    storeInformationSubtitle: 'يظهر على الفواتير والتقارير',
    userManagement: 'إدارة المستخدمين',
    systemUsers: 'مستخدمو النظام',
    members: 'أعضاء',
    storeName: 'اسم المتجر',
    storeLogo: 'شعار المتجر',
    uploadLogo: 'رفع الشعار',
    changeLogo: 'تغيير الشعار',
    logoHelp: 'سيظهر الشعار في الفواتير (يفضل صورة مربعة)',
    logoSize: 'عرض شعار الفاتورة (بكسل)',
    logoSizeHelp: 'عرض شعار الفاتورة المطبوعة. المسموح: 40–400.',
    logoSizeInvalid: 'يجب أن يكون عرض الشعار بين 40 و400 بكسل.',
    refundPeriod: 'نافذة الاسترجاع (أيام)',
    refundPeriodHelp: 'يُسمح بالاسترجاع من نقطة البيع للطلبات خلال آخر N يوماً (1–365).',
    refundPeriodInvalid: 'يجب أن تكون نافذة الاسترجاع بين 1 و365 يوماً.',
    storeAddress: 'عنوان المتجر',
    address: 'العنوان',
    phone1: 'الهاتف 1',
    phone2: 'الهاتف 2',
    phone3: 'الهاتف 3',
    phoneNumber: 'رقم الهاتف',
    phoneNumbers: 'أرقام الهواتف',
    website: 'الموقع الإلكتروني',
    websiteUrl: 'رابط الموقع',
    websiteOnReceipt: 'الموقع في الفاتورة',
    dontInclude: 'عدم إضافة',
    showAsLink: 'عرض كرابط',
    showAsQr: 'عرض كرمز QR',
    howToDisplayWebsite: 'كيفية عرض الموقع في الفواتير',
    facebook: 'فيسبوك',
    instagram: 'انستجرام',
    tiktok: 'تيك توك',
    xTwitter: 'إكس (تويتر)',
    socialMediaUrls: 'روابط التواصل الاجتماعي',
    platform: 'المنصة',
    url: 'الرابط',
    includeInReceipt: 'إضافة إلى الفاتورة',
    lowStockThreshold: 'حد المخزون المنخفض',
    lowStockThresholdHelp: 'المنتجات التي تقل عن هذه الكمية ستُعلّم كمخزون منخفض',
    tax: 'الضريبة (%)',
    receiptFooter: 'رسالة أسفل الفاتورة',
    deliveryFees: 'رسوم التوصيل',
    deliveryRegionsFees: 'مناطق ورسوم التوصيل',
    deliveryFeeSettings: 'إعدادات رسوم التوصيل',
    includeDeliveryFeeInSales: 'إضافة رسوم التوصيل إلى إجمالي المبيعات',
    requireRefNumNonCash: 'طلب رقم مرجعي لمدفوعات غير النقدي',
    discountRequiresApproval: 'يتطلب موافقة المشرف/المسؤول على الخصومات',
    allowNegativeStock: 'السماح بالبيع عند نفاد المخزون',
    allowNegativeStockHelp: 'سيظهر تحذير للكاشير بدلاً من منعه من البيع عندما يكون المخزون المسجَّل صفرًا أو أقل، وقد تصبح كمية المخزون سالبة حتى يتم تصحيحها.',
    storePromo: 'عرض المتجر',
    storePromoHelp: 'عرض واحد يُطبّق تلقائياً على جميع طلبات نقطة البيع. اتركه فارغاً للتعطيل.',
    promoName: 'اسم العرض',
    promoNamePlaceholder: 'مثال: رمضان 10%',
    promoPercentage: 'نسبة العرض %',
    clearPromo: 'إزالة العرض',
    promoEnterBoth: 'يرجى إدخال اسم العرض ونسبته معاً',
    promoOnlyOne: 'يُسمح بعرض واحد فقط. عدّل أو احذف العرض الحالي أولاً.',
    noStorePromo: 'لا يوجد عرض نشط. أضف عرضاً من الأعلى.',
    deletePromoConfirm: 'إزالة عرض المتجر هذا؟',
    promoNameRequired: 'اسم العرض مطلوب عند تحديد نسبة العرض',
    promoNameMaxLength: 'اسم العرض يجب ألا يتجاوز 20 حرفاً',
    promoPercentageInvalid: 'نسبة العرض يجب أن تكون بين 0 و 100 (أكبر من 0)',
    deliveryFeeIncludedHelp: 'عند التفعيل، يتم إضافة رسوم التوصيل إلى إجمالي المبيعات',
    region: 'المنطقة',
    regionName: 'اسم المنطقة',
    fee: 'الرسوم',
    feeEgp: 'الرسوم (ج.م)',
    addRegion: 'إضافة منطقة',
    removeRegion: 'إزالة المنطقة',
    noDeliveryRegions: 'لا توجد مناطق توصيل. أضف مناطق أعلاه.',
    deliveryPersonnel: 'موظفو التوصيل',
    addDeliveryPerson: 'إضافة موظف توصيل',
    deliveryPersonName: 'الاسم',
    deliveryPersonPhone: 'الهاتف',
    deliveryPersonNameRequired: 'الاسم مطلوب',
    deliveryPersonPhoneRequired: 'رقم الهاتف مطلوب',
    deliveryPersonPhoneUnique: 'هذا الرقم موجود بالفعل',
    deleteDeliveryPersonConfirm: 'حذف موظف التوصيل؟',
    noDeliveryPersons: 'لا يوجد موظفو توصيل.',
    noPhoneNumbers: 'لا توجد أرقام هواتف. أضف أرقام أعلاه.',
    noSocialMedia: 'لا توجد روابط تواصل اجتماعي. أضف روابط أعلاه.',
    saveSettings: 'حفظ الإعدادات',
    saveChanges: 'حفظ التغييرات',
    saving: 'جاري الحفظ...',
    saved: 'تم الحفظ',
    settingsSaved: 'تم حفظ الإعدادات بنجاح',
    users: 'المستخدمين',
    addUser: 'إضافة مستخدم',
    addNewUser: 'إضافة مستخدم جديد',
    editUser: 'تعديل المستخدم',
    deleteUser: 'حذف المستخدم',
    username: 'اسم المستخدم',
    usernameTaken: 'اسم المستخدم مستخدم بالفعل',
    password: 'كلمة المرور',
    newPasswordOptional: 'كلمة المرور الجديدة (اختياري)',
    confirmPassword: 'تأكيد كلمة المرور',
    fullName: 'الاسم الكامل',
    role: 'الوظيفة',
    admin: 'مدير',
    owner: 'المالك',
    manager: 'مشرف',
    cashier: 'كاشير',
    ownerAccountProtected: 'لا يمكن لأحد تعديل حساب مالك المتجر.',
    ownerChangePasswordHint: 'يمكنك تغيير كلمة المرور فقط من هنا.',
    adminChangePasswordHint: 'يمكنك تغيير كلمة المرور فقط من هنا.',
    roleNotAllowed: 'ليس لديك صلاحية لتعيين هذه الوظيفة.',
    canApproveDiscounts: 'يمكنه الموافقة على الخصومات',
    canApproveDiscountsHint: 'يسمح لرمز الاسترجاع الخاص بهذا المستخدم بالموافقة على خصومات نقطة البيع.',
    active: 'نشط',
    inactive: 'غير نشط',
    activate: 'تفعيل',
    deactivate: 'إلغاء التفعيل',
    confirmToggleActivateVerb: 'تفعيل',
    confirmToggleDeactivateVerb: 'إلغاء تفعيل',
    userStatus: 'الحالة',
    confirmDeleteUser: 'هل أنت متأكد من حذف هذا المستخدم؟',
    confirmToggleStatus: 'هل أنت متأكد من {action} {name}؟',
    userAdded: 'تمت إضافة المستخدم بنجاح',
    userUpdated: 'تم تحديث المستخدم بنجاح',
    userDeleted: 'تم حذف المستخدم بنجاح',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    fullNameMaxLength: 'الاسم الكامل يجب ألا يتجاوز 40 حرفاً',
    usernameMaxLength: 'اسم المستخدم يجب ألا يتجاوز 20 حرفاً',
    passwordLength: 'كلمة المرور يجب أن تكون بين 4 و 30 حرفاً',
    allRoles: 'كل الوظائف',
    allStatuses: 'كل الحالات',
    filterByRole: 'تصفية حسب الوظيفة',
    filterByStatus: 'تصفية حسب الحالة',
    clearFilters: 'مسح التصفية',
    searchUsers: 'البحث عن المستخدمين...',
    searchUsersByNameOrUsername: 'البحث بالاسم أو اسم المستخدم…',
    usersNoSearchMatches: 'لا يوجد مستخدمون يطابقون البحث.',
    cannotEditSelf: 'لا يمكنك تغيير دورك الخاص',
    managersCanOnlyEditCashiers: 'المشرفون يمكنهم تعديل الكاشيرين فقط',
    managersCanOnlyCreateCashiers: 'المشرفون يمكنهم إنشاء كاشيرين فقط',
    managersCannotChangeRoles: 'المشرفون لا يمكنهم تغيير الوظائف',
    managerChangePasswordHint: 'أدخل كلمة المرور الجديدة.',
    newPassword: 'كلمة المرور الجديدة',
    cannotDeactivateSelf: 'لا يمكنك إلغاء تفعيل نفسك',
    cannotDeleteSelf: 'لا يمكنك حذف نفسك',
    license: 'الترخيص',
    licenseTabSubtitle: 'حالة تفعيل هذا الجهاز',
    licenseChecking: 'جاري التحقق من الترخيص…',
    licenseServerMobileLink: 'رابط تطبيق الإدارة للجوال',
    licenseServerMobileLinkNotSet: 'غير محدد',
    licenseBootstrapClosedHint:
      'اطلب من مسؤول المتجر تفعيل هذه الجهاز من الإعدادات ← الترخيص على جهاز الكاشير الرئيسي.',
    licenseSlotsTitle: 'الأجهزة',
    licenseSlotsSubtitle:
      'فعّل فتحات الترخيص الإضافية لأجهزة كاشير أخرى (بعد اكتمال إعداد الجهاز الأول).',
    licenseSlotsLicenseMeta: 'مفتاح الترخيص: {key} · الحد الأقصى للمحطات: {max}',
    licenseSlotsSync: 'مزامنة الآن',
    licenseSlotsLoading: 'جاري تحميل الفتحات…',
    licenseSlotsEmpty: 'لا توجد فتحات لهذا مفتاح الترخيص.',
    licenseSlotsColSlot: 'معرف الجهاز',
    licenseSlotsColStatus: 'حالة الخادم',
    licenseSlotsColTill: 'الجهاز المرتبطة',
    licenseSlotsColActions: 'إجراءات',
    licenseSlotsStatus_active: 'نشط',
    licenseSlotsStatus_pending: 'معلق',
    licenseSlotsStatus_revoked: 'ملغى',
    licenseSlotsActivate: 'تفعيل الجهاز',
    licenseSlotsActivating: 'جاري التفعيل…',
    licenseSlotsActivateTitle: 'تفعيل جهاز جديدة',
    licenseSlotsSlotLabel: 'الفتحة:',
    licenseSlotsTillName: 'اسم الجهاز',
    licenseSlotsTillNamePlaceholder: 'مثال: كاشير أمامي',
    licenseSlotsTillNameRequired: 'اسم الجهاز مطلوب',
    licenseSlotsTillNameTooLong: 'يجب ألا يتجاوز الاسم 50 حرفاً',
    licenseSlotsActivationFailed: 'فشل التفعيل',
    licenseSlotsActivatedNamed: 'تم تفعيل "{name}"',
    licenseSlotsRegisterUuidHint: 'معرف الجهاز — سلّمه لمشغّل الكاشير',
    licenseSlotsUnbind: 'إلغاء الربط',
    licenseSlotsUnbinding: 'جاري إلغاء الربط…',
    licenseSlotsUnbindTitle: 'إلغاء ربط الفتحة؟',
    licenseSlotsBoundTo: 'مرتبطة حالياً بـ "{name}"',
    licenseSlotsUnbindWarning:
      'هذا يزيل الربط المحلي والرمز فقط. لا يُلغى على خادم الترخيص — افعل ذلك من لوحة خادم الترخيص.',
    licenseSlotsUnbindFailed: 'فشل إلغاء الربط',
    licenseSlotsRevokedHint: 'أعد التعيين على خادم الترخيص أولاً',
    licenseBannerExpiresOneDay: 'ينتهي الترخيص خلال يوم واحد.',
    licenseBannerExpiresDays: 'ينتهي الترخيص خلال {days} أيام.',
    licenseBannerDaysRemainingOne: 'يوم واحد متبقٍ',
    licenseBannerDaysRemaining: '{days} أيام متبقية',
    licenseBannerDismiss: 'إخفاء',
    // Tabs
    database: 'قاعدة البيانات',
    databaseInfo: 'البيانات مخزنة على خادم المتجر (PostgreSQL). إنشاء نسخ احتياطية أو استعادة أو حذف جميع البيانات. للمسؤول فقط.',
    databaseBackup: 'نسخ احتياطي',
    databaseUpload: 'رفع / استعادة',
    databaseDrop: 'حذف جميع البيانات',
    databaseDropTransactional: 'حذف البيانات المعاملية',
    databaseDropTransactionalConfirm:
      'حذف الطلبات والجلسات والاسترجاعات وغيرها؟ ستُحفظ: المستخدمون، المنتجات، الأقسام، الأجهزة، بيانات المتجر، إعدادات الترخيص، العملاء، الموردون، ومندوبو التوصيل. متابعة؟',
    databaseDropTransactionalSuccess:
      'تم حذف البيانات المعاملية. المستخدمون والمنتجات والأقسام والأجهزة وبيانات المتجر والعملاء والموردون ومندوبو التوصيل محفوظون.',
    databaseDropTransactionalSuccessResetSessions:
      'تم حذف البيانات المعاملية وإعادة تعيين أرقام الجلسات. المستخدمون والمنتجات والأقسام والأجهزة وبيانات المتجر وإعدادات الترخيص والعملاء والموردون ومندوبو التوصيل محفوظون.',
    databaseResetSessionsLabel: 'إعادة تعيين أرقام الجلسات (اختياري)',
    databaseResetSessionsPlaceholder: 'اكتب RESET_SESSIONS لإعادة التعيين',
    databaseResetSessionsHint: 'اتركه فارغاً للاحتفاظ بالرقم التالي للجلسة كما هو. اكتب RESET_SESSIONS بالضبط لبدء ترقيم الجلسات من 1.',
    databaseDropDescription:
      'ماذا يفعل هذا:\n• يفرّغ تقريباً كل الجداول عدا حسابات المستخدمين وأجهزة نقطة البيع وإعدادات الترخيص.\n• تُحذف بيانات المتجر والمنتجات والأقسام والعملاء والطلبات والجلسات وغيرها.\n• يُعاد ترقيم الجلسات من 1.\n• الاستعادة فقط عبر استرجاع نسخة احتياطية.',
    databaseDropTransactionalDescription:
      'ماذا يفعل هذا:\n• يحذف السجل التشغيلي: جلسات الصندوق والطلبات والمدفوعات والمرتجعات والمصروفات ومشتريات الموردين والإقفالات الشهرية وسجل التدقيق.\n• يبقى دون تغيير: المستخدمون والمنتجات والأقسام والأجهزة وإعدادات المتجر وإعدادات الترخيص والعملاء والموردون ومندوبو التوصيل.\n• اختياري: اكتب RESET_SESSIONS في الحقل أدناه لإعادة ترقيم الجلسات من 1؛ اتركه فارغاً للاحتفاظ بالرقم التالي للجلسة.',
    databaseAdminPasswordHint: 'أدخل كلمة مرور المسؤول لتأكيد هذا الإجراء.',
    databasePasswordRequired: 'كلمة مرور المسؤول مطلوبة.',
    databaseSelectFile: 'يرجى اختيار ملف نسخ احتياطي .sql.',
    databaseRestoreSuccess: 'تم استعادة قاعدة البيانات بنجاح.',
    databaseBackupConfirm: 'إنشاء نسخة احتياطية من قاعدة البيانات؟',
    databaseUploadConfirm: 'استعادة قاعدة البيانات من النسخة الاحتياطية؟',
    databaseDropConfirm:
      'حذف جميع البيانات؟ حسابات المستخدمين والأجهزة ستُحفظ حتى تتمكن من الاستعادة من النسخة الاحتياطية. متابعة؟',
    databaseBackupRecommendation: 'التوصية: قم بعمل نسخة احتياطية أولاً قبل المتابعة.',
    databaseDropSuccess:
      'تم حذف جميع البيانات وإعادة تعيين أرقام الجلسات. حسابات المستخدمين والأجهزة محفوظة. يمكنك الاستعادة من النسخة الاحتياطية.',
    adminPassword: 'كلمة مرور المسؤول',
    invalidAdminPassword: 'كلمة مرور المسؤول غير صحيحة',
    security: 'الأمان',
    securityInfo: 'مهلة الجلسة والأمان يديرها التطبيق. قم بتغيير كلمة المرور عبر تعديل المستخدم في إدارة المستخدمين.',
    about: 'حول',
    aboutAppName: 'كاونتر',
    aboutTagline: 'نظام نقاط البيع',
    aboutInfo: 'كاونتر - نظام كاشير سحابي. بيانات متجرك تعمل على كاونتر نمو.',
    aboutCompany: 'أحد منتجات نمو.',
    aboutWebsite: 'الموقع الإلكتروني',
    aboutScanQr: 'امسح الرمز لزيارة الموقع',
    aboutSupport: 'الدعم الفني والاستفسارات',
    aboutWhatsapp: 'واتساب',
    barcode: 'الباركود',
    uuidBarcodePrinting: 'طباعة باركود المعرف',
    printBarcodeForAdminManager: 'طباعة باركود المعرف للمدراء والمشرفين. تُستخدم هذه الباركودات لعملية الموافقة على الاسترجاع أو الخصومات.',
    printYourBarcode: 'اطبع باركود معرفك لعملية الموافقة على الاسترجاع.',
    printBarcode: 'طباعة الباركود',
    downloadBarcode: 'تحميل',
    refundCode: 'الرمز',
    loadingUsers: 'جاري تحميل المستخدمين...',
    noUsersAvailable: 'لا يوجد مستخدمون.',
    searchRefundBarcodeUsers: 'ابحث بالاسم أو اسم المستخدم أو رمز الاسترجاع…',
    noRefundBarcodeFilterMatch: 'لا يوجد مستخدمون يطابقون التصفية.',
    accessDenied: 'الوصول مرفوض. فقط المدراء والمشرفون يمكنهم طباعة باركود المعرف.',
    forRefundApproval: 'لعملية الموافقة على الاسترجاع والخصومات',
    cashiersSection: 'الكاشيرون',
    renewCode: 'تجديد الكود',
    renewCodeWarning: 'سيؤدي ذلك إلى إلغاء كود الحالي لـ {name} فوراً. سيتم رفض أي شخص يستخدم الكود القديم على الفور. هل تريد المتابعة؟',
    confirmRenew: 'نعم، جدّد',
    renewCodeSuccess: 'تم تجديد الكود بنجاح.',
    renewCodeFailed: 'فشل تجديد الكود. يرجى المحاولة مرة أخرى.',
  },

  // Error messages
  errors: {
    somethingWentWrong: 'حدث خطأ ما',
    tryAgain: 'يرجى المحاولة مرة أخرى',
    networkError: 'خطأ في الشبكة. يرجى التحقق من الاتصال.',
    unauthorized: 'غير مصرح. يرجى تسجيل الدخول مرة أخرى.',
    forbidden: 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
    notFound: 'المورد غير موجود.',
    serverError: 'خطأ في الخادم. يرجى المحاولة لاحقاً.',
    validationError: 'يرجى التحقق من المدخلات والمحاولة مرة أخرى.',
    sessionExpired: 'انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.',
  },

  // Confirmations
  confirm: {
    delete: 'هل أنت متأكد من حذف هذا العنصر؟',
    logout: 'هل أنت متأكد من تسجيل الخروج؟',
    clearCart: 'هل أنت متأكد من إفراغ السلة؟',
    cancelOrder: 'هل أنت متأكد من إلغاء هذا الطلب؟',
    closeSession: 'هل أنت متأكد من إغلاق هذه الجلسة؟',
  },

  // Currency
  currency: {
    egp: 'ج.م',
    symbol: 'ج.م',
  },

  // Alert messages
  alerts: {
    // POS alerts
    invalidWeightBarcode: 'صيغة باركود الوزن غير صالحة',
    itemNotFoundForSku: 'العنصر غير موجود للرمز: {sku}',
    itemNotFoundForBarcode: 'العنصر غير موجود للباركود: {barcode}',
    itemNotWeightConfigured: 'العنصر "{name}" غير معد كعنصر وزني',
    itemOutOfStock: 'العنصر نفذ من المخزون: {name}',
    notEnoughStockAvailable: 'المخزون غير كافٍ. المتاح: {available} {unit}',
    notEnoughStockForItem: 'المخزون غير كافٍ لـ: {name}. إجمالي المخزون: {total}، في السلة: {inCart}، المتاح: {available}',
    sellingWithoutStock: 'لا يوجد مخزون مسجَّل لـ {name} - سيتم البيع مع ذلك. يرجى إعادة الجرد وتحديث المخزون قريبًا.',
    noOpenSession: 'لا توجد جلسة مفتوحة. يرجى فتح جلسة أولاً.',
    pleaseSelectDeliveryRegion: 'يرجى اختيار منطقة التوصيل.',
    customerPhoneRequired: 'رقم هاتف العميل مطلوب لطلبات التوصيل.',
    customerNameRequired: 'اسم العميل مطلوب لطلبات التوصيل.',
    customerAddressRequired: 'عنوان العميل مطلوب لطلبات التوصيل.',
    deliveryPersonRequired: 'يرجى اختيار موظف التوصيل.',
    cartIsEmpty: 'السلة فارغة',
    cashMustBeGreaterOrEqual: 'المبلغ النقدي يجب أن يكون أكبر من أو يساوي المبلغ الإجمالي',
    pleaseEnterTransactionNumber: 'يرجى إدخال رقم العملية',
    pleaseEnterCashAmount: 'يرجى إدخال المبلغ النقدي',
    cashMustBeLessThanTotal: 'المبلغ النقدي يجب أن يكون أقل من الإجمالي للدفع المختلط',
    mixedMinCashAmount: 'يجب أن يكون المبلغ النقدي 1 ج.م على الأقل للدفع المختلط',
    mixedMinInstapayAmount: 'يجب أن يكون مبلغ انستاباي 1 ج.م على الأقل في الدفع المختلط',
    mixedMinWalletAmount: 'يجب أن يكون مبلغ المحفظة 5 ج.م على الأقل في الدفع المختلط',
    mixedNotAvailableForTotal: 'الدفع المختلط غير متاح لهذا الإجمالي مع طريقة الدفع المختارة',
    pleaseEnterCardTransaction: 'يرجى إدخال رقم عملية البطاقة',
    pleaseEnterInstapayTransaction: 'يرجى إدخال رقم عملية انستاباي',
    pleaseEnterWalletTransaction: 'يرجى إدخال رقم عملية المحفظة',
    paymentRefMaxLength: 'رقم مرجع الدفع يجب ألا يتجاوز 50 حرفاً',
    refundReasonMaxLength: 'ملاحظات الاسترداد يجب ألا تتجاوز 150 حرفاً',
    discountNotesMaxLength: 'ملاحظات الخصم يجب ألا تتجاوز 50 حرفاً',
    reviewNotesMaxLength: 'ملاحظات مراجعة الجلسة يجب ألا تتجاوز 250 حرفاً',
    forceCloseNotesMaxLength: 'ملاحظات الإغلاق القسري يجب ألا تتجاوز 150 حرفاً',
    invalidUuidFormat: 'يرجى إدخال UUID بصيغة صحيحة',
    failedToPrintReceipt: 'فشل في طباعة الفاتورة. يرجى المحاولة مرة أخرى.',
    pleasePrintReceiptFirst: 'يرجى طباعة الفاتورة أولاً',
    openingAmountNegative: 'مبلغ الافتتاح لا يمكن أن يكون سالباً',
    closingAmountNegative: 'مبلغ الإغلاق لا يمكن أن يكون سالباً',
    transactionFailed: 'فشلت العملية: {message}. يرجى المحاولة مرة أخرى.',
    customerDeleteDeliveryPersonConflict: 'لا يمكن حذف العميل: لدى هذا العميل طلبات توصيل مع موظفين توصيل معينين. يرجى إزالة موظف التوصيل من تلك الطلبات أولاً.',
    insufficientStockForCheckout: 'المخزون غير كافٍ لـ "{name}". المتاح: {available}. ربما تمت عملية بيع أخرى في نفس الوقت.',
    quantityReducedToAvailable: 'تم تخفيض الكمية للمتاح لـ "{name}" ({available}). ربما تمت عملية بيع أخرى. يرجى المحاولة مرة أخرى.',
    itemRemovedOutOfStock: 'تمت إزالة "{name}" من السلة – نفد المخزون. ربما تمت عملية بيع أخرى. يرجى المحاولة مرة أخرى.',
    transactionInProgressConfirm: 'عملية قيد التنفيذ. هل أنت متأكد من المغادرة؟',

    // Inventory alerts
    failedToSave: 'فشل الحفظ: {error}',
    failedToSaveCategory: 'فشل حفظ القسم: {error}',
    itemNameRequired: 'اسم العنصر مطلوب',
    categoryRequired: 'يرجى اختيار قسم',
    stockQuantityInvalid: 'كمية المخزون يجب أن تكون 0 أو أكثر',
    costPriceNegative: 'سعر التكلفة لا يمكن أن يكون سالباً',
    sellingPriceNegative: 'سعر البيع لا يمكن أن يكون سالباً',
    profitMarginNegative: 'يجب أن يكون سعر البيع مساوياً لسعر التكلفة أو أعلى حتى لا يصبح الربح سالباً.',
    purchaseUnitPriceInvalid: 'يجب أن يكون سعر الوحدة أكبر من 0.',
    purchaseSellingBelowUnitCost: 'يجب أن يكون سعر بيع الوحدة مساوياً لسعر تكلفة الوحدة أو أعلى حتى لا يصبح الربح سالباً.',
    purchaseQuantityPieceWholeNumber: 'يجب أن تكون الكمية عدداً صحيحاً للمنتجات المحسوبة بالقطعة.',
    purchaseQuantityKgMaxDecimals: 'يجب ألا يزيد عدد الخانات العشرية عن 3 للمنتجات المحسوبة بالكيلو.',
    deleteFailed: 'فشل الحذف',
    productHasPurchases: 'لا يمكن حذف هذا المنتج لأنه مرتبط بسجلات مشتريات. احذف المشتريات أولاً.',
    productReferenced: 'لا يمكن حذف هذا المنتج لأنه مرتبط بسجلات أخرى (مثل الطلبات أو المشتريات).',
    productInOffer: 'لا يمكن حذف هذا المنتج لأنه مستخدم في عرض أو أكثر. أزِله من العروض أولاً.',
    categoryHasProductsInOffers: 'لا يمكن حذف هذا القسم لأنه يحتوي على منتجات مستخدمة في عرض أو أكثر. أزِل تلك المنتجات من العروض أولاً.',
    categoryHasProductsWithPurchases:
      'لا يمكن حذف هذا القسم لأنه يحتوي على منتجات مرتبطة بسجلات مشتريات. انقل أو احذف تلك المنتجات أو مشترياتها أولاً.',
    productPurchaseRestrict: 'لا يمكن حذف هذا المنتج لأنه مرتبط بسجلات مشتريات. احذف المشتريات أولاً.',

    // Settings alerts
    enterBothRegionAndFee: 'يرجى إدخال المنطقة والرسوم',
    feeMustBePositive: 'الرسوم يجب أن تكون رقماً موجباً صالحاً',
    regionAlreadyExists: 'المنطقة موجودة بالفعل',
    pleaseEnterPhoneNumber: 'يرجى إدخال رقم الهاتف',
    phoneNumberAlreadyExists: 'رقم الهاتف هذا موجود بالفعل',
    pleaseEnterUrl: 'يرجى إدخال الرابط',
    platformAlreadyExists: 'هذه المنصة موجودة بالفعل',
    deleteDeliveryRegion: 'حذف منطقة التوصيل هذه؟',
    deletePhoneNumber: 'حذف رقم الهاتف هذا؟',
    deleteSocialMedia: 'حذف رابط التواصل الاجتماعي هذا؟',
    failedToGenerateBarcode: 'فشل إنشاء الباركود',
    storeNameMaxLength: 'اسم المتجر يجب ألا يتجاوز 20 حرفاً',
    addressMaxLength: 'العنوان يجب ألا يتجاوز 50 حرفاً',
    websiteMaxLength: 'رابط الموقع يجب ألا يتجاوز 40 حرفاً',
    receiptFooterMaxLength: 'تذييل الإيصال يجب ألا يتجاوز 50 حرفاً',
    regionNameMaxLength: 'اسم منطقة التوصيل يجب ألا يتجاوز 20 حرفاً',
    phoneNumberMaxLength: 'رقم الهاتف يجب ألا يتجاوز 15 حرفاً',
    socialUrlMaxLength: 'رابط التواصل الاجتماعي يجب ألا يتجاوز 70 حرفاً',
    deliveryPersonNameMaxLength: 'اسم موظف التوصيل يجب ألا يتجاوز 30 حرفاً',
    deliveryPersonPhoneMaxLength: 'رقم هاتف موظف التوصيل يجب ألا يتجاوز 15 حرفاً',
    customerNameMaxLength: 'اسم العميل يجب ألا يتجاوز 30 حرفاً',
    customerPhoneMaxLength: 'رقم هاتف العميل يجب ألا يتجاوز 15 حرفاً',
    customerAddressMaxLength: 'عنوان العميل يجب ألا يتجاوز 70 حرفاً',
    posDeliveryAddressMaxLength: 'عنوان التوصيل يجب ألا يتجاوز 50 حرفاً',
    supplierNameMaxLength: 'اسم المورد يجب ألا يتجاوز 30 حرفاً',
    supplierPhoneMaxLength: 'رقم هاتف المورد يجب ألا يتجاوز 15 حرفاً',
    expenseNameMaxLength: 'اسم المصروف يجب ألا يتجاوز 50 حرفاً',
    expenseCategoryNameMaxLength: 'اسم قسم المصروف يجب ألا يتجاوز 30 حرفاً',
    inventoryCategoryNameMaxLength: 'اسم القسم يجب ألا يتجاوز 30 حرفاً',
    productNameMaxLength: 'اسم المنتج يجب ألا يتجاوز 40 حرفاً',
    productSkuMaxLength: 'رمز المنتج (SKU) يجب ألا يتجاوز 50 حرفاً',

    // Session alerts
    enterValidClosingCash: 'يرجى إدخال قيمة نقدية إغلاق صالحة.',
    closingCashMustBeNonNegative: 'يجب أن تكون قيمة النقدية صفر أو أكثر.',
    managersCannotEditReviewed: 'لا يمكن للمشرفين تعديل جلسة تمت مراجعتها.',
    failedToForceCloseSession: 'فشل في الإغلاق القسري للجلسة',
    failedToReviewSession: 'فشل في مراجعة الجلسة',
    failedToOpenSession: 'فشل في فتح الجلسة',
    failedToCloseSession: 'فشل في إغلاق الجلسة',

    // Refund alerts
    failedToLoadRefund: 'فشل تحميل تفاصيل الاسترجاع',
    pleaseEnterReceiptNumber: 'يرجى إدخال رقم الإيصال',
    orderNotFoundOrOlderThanOneDay: 'الطلب غير موجود أو أقدم من يوم واحد',
    orderNotFoundOrOlderThanDays: 'الطلب غير موجود أو أقدم من {days} يوم',
    failedToFindOrder: 'فشل في العثور على الطلب',
    pleaseEnterApproverUuid: 'يرجى إدخال رمز الاسترجاع للمشرف/المسؤول',
    pleaseEnterApproverCode: 'يرجى إدخال رمز الاسترجاع للمشرف/المسؤول',
    invalidApproverFormat: 'يرجى إدخال رمز استرجاع صحيح (16 حرف)',
    invalidApprover: 'مشرف غير صالح: يجب أن ينتمي رمز الاسترجاع إلى مدير أو مسؤول',
    inactiveApprover: 'حساب الموافق غير مفعّل. استخدم رمز لمدير أو مسؤول نشط.',
    noDiscountPermission: 'هذا الموافق غير مصرح له بالموافقة على الخصومات.',
    failedToProcessRefund: 'فشل في معالجة الاسترجاع',
    orderAlreadyRefunded: 'تم استرجاع هذا الطلب بالفعل',

    // User/Settings alerts
    failedToUpdateUserStatus: 'فشل في تحديث حالة المستخدم',
    usernameAlreadyTaken: 'اسم المستخدم هذا مستخدم بالفعل',
    failedToCreateUser: 'فشل في إنشاء المستخدم',
    failedToUpdateUser: 'فشل في تحديث المستخدم',
    deleteUserConfirm: 'حذف هذا المستخدم؟',
    failedToDeleteUser: 'فشل في حذف المستخدم',

    // Load/Save fallbacks
    failedToLoadRefunds: 'فشل تحميل الاسترجاعات',
    failedToLoadPurchases: 'فشل تحميل المشتريات',
    failedToLoadSales: 'فشل تحميل المبيعات',
    failedToLoadCustomers: 'فشل تحميل العملاء',
    failedToLoadDeliveryPersons: 'فشل تحميل موظفي التوصيل',
    failedToLoadExpenses: 'فشل تحميل المصروفات',
    failedToSaveSupplier: 'فشل حفظ المورد',
    failedToDeletePurchase: 'فشل حذف المشتريات',
    failedToSaveExpense: 'فشل حفظ المصروف',
    failedToSaveExpenseCategory: 'فشل حفظ قسم المصروف',
    failedToDeleteExpense: 'فشل حذف المصروف',
    failedToDeleteExpenseCategory: 'فشل حذف قسم المصروف',

    // General
    unknownError: 'خطأ غير معروف',
    failedToUpdate: 'فشل التحديث',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
  },
};

export default ar;
